var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"feedbackTextParent",staticClass:"animation-feedback"},[_c('span',{ref:"feedbackText",staticClass:"feedback-text"},[_vm._t("message")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }